// Import components
import "../../components/material-toggle.js";
import "../../components/paper-options.js";
import "../../components/acryl-options.js";
import "../../components/aluminium-options.js";
import "../../components/tegel-options.js";
import "../../components/font-options.js";
import "../../components/gift-options.js";
import "../../components/wallable-watermark.js";
import "../../components/route-options.js";
import "../../components/map-style-selector.js";
import "../../components/kader-selector.js";
import "../../components/orientation-selector.js";

import "html2canvas";
import "mapbox-gl/dist/mapbox-gl.css";
import "@woocommerce/woocommerce-rest-api";

import mapboxgl from "mapbox-gl";
import html2canvas from "html2canvas";
import * as $ from "jquery";
import * as bootstrap from "bootstrap";
import { Options } from "./options-sportsmap.js";
import { waitForSportsmapPreview } from "./helpers/sportsmap-ready.js";
import { getShippingDate } from "./helpers/shipping-date.js";
import { getShoppingBagSummary } from "./helpers/shopping-bag-summary.js";
import { DebugReporter } from "./helpers/debug-reporter.js";
import { resizePosterPreview } from "./helpers/resize-poster-preview.js";
import { initializeI18n } from "./i18n/initialize.js";
import { resolveCatalogProduct } from "./catalog/product-catalog.js";
import { getBuilderUrl } from "./config/builder-routes.js";
import {
  uploadGeoJson,
  uploadJson,
  uploadProductScreenshot,
} from "./helpers/image-uploader.js";
import {
  addRoute,
  buildRouteEndpointsGeojson,
  buildRoutesGeojson,
  clearPersistedRoutes,
  clearRoutes,
  getRouteCoordinates,
  loadRoutes,
  removeRoute,
  routeStore,
  serializeRoutes,
  updateRoute,
} from "./stores/route-store.js";

mapboxgl.accessToken = process.env.MAPBOXTOKEN;

let marketContext;
let t = (key) => key;
let formatCurrency = (value) => `€${Number(value).toFixed(2).replace(".", ",")}`;
let formatDate = (value) => String(value);
let woocommerceUrl;
let routePlaceholderImage;
let routesApiUrl;
let sportsRoutes = { routes: [] };
let routesLoadPromise = null;

const converter = require("@mapbox/togeojson");
const turf = require("@turf/turf");
const DOMParser = require("xmldom").DOMParser;

const MapStyle1 = process.env.MAPSTYLESPORTSALU; // White
const MapStyle2 = process.env.MAPSTYLESPORTSOUTDOORS; // Outdoors
const MapStyle3 = process.env.MAPSTYLESPORTSBLACK; // Black
const MapStyle4 = process.env.MAPSTYLESPORTSBLANC; // Leeg

const options = new Options();

async function initializeSportsmap(signal) {
  ({ marketContext, t, formatCurrency, formatDate } = await initializeI18n());
  woocommerceUrl = marketContext.services.woocommerceBaseUrl;
  routePlaceholderImage = marketContext.services.routePlaceholderImage;
  routesApiUrl = marketContext.services.routesEndpoint;

  await options.init();
  signal.throwIfAborted();
  clearPersistedRoutes();

  let PosterPreviewImage, routeQueryParam, RoutesModal, searchTimer;
  let ShowMobileSettingPanel = false;
  let PrintTypeSelected = true;
  let RoutesInitialized = false;
  let routesInitializationComplete = false;
  let initialDesignSnapshot = null;
  let mapWasEdited = false;
  let designWasSubmitted = false;
  let BuilderName = $("body").attr("id");

  const routesWrapper = "running-routes";
  const routeLineID = "running-routes-line";
  const routeCasingID = "running-routes-casing";

  const markerSourceID = "running-routes-markers";
  const markerOutlineID = "running-routes-marker-outline";
  const markerBorderID = "running-routes-marker-border";
  const markerFillID = "running-routes-marker-fill";
  const routeCameraPadding = {
    top: 80,
    bottom: 350,
    left: 80,
    right: 80,
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const hasConfigFileUrl = Boolean(urlSearchParams.get("configFileUrl"));
  const routeIdFromUrl = urlSearchParams.get("routeID");
  const parsedRouteId = Number(routeIdFromUrl);
  const hasRouteQueryParam = routeIdFromUrl !== null;
  routeQueryParam =
    hasRouteQueryParam &&
    routeIdFromUrl.trim() !== "" &&
    Number.isInteger(parsedRouteId) &&
    parsedRouteId > 0
      ? parsedRouteId
      : null;

  let mapCoordinates = options.get(
    "mapCoordinates",
    JSON.stringify([13.355054999999993, 52.47059945489795]),
    "object",
  );
  let MapZoom = options.get("mapZoom", 11.25);
  let SettingsPanel = options.get("settingsPanel", "map");
  let PosterSize = options.get("posterSize", "small");
  let PosterFrame = options.get("posterFrame", "black");
  let PosterKader = options.get("posterKader", "with");
  let PosterStyle = options.get("SMPosterStyle", 1);
  var PosterOrientation = options.get("posterOrientation", "portrait");
  let PrintType = options.get("printType", "paper");
  let FontStyle = options.get("SMFontStyle", "modern");
  let routeThickness = parseInt(options.get("routeThickness", 5));
  let routeColor = options.get("routeColor", "#000000");
  let startColor = options.get("startColor", "#000000");
  let endColor = options.get("endColor", "#000000");
  let showEndPoints = options.get("showEndPoints", true, "bool");
  let unlockMap = options.get("unlockMap", false, "bool");
  let labelsOverRoute = options.get("labelsOverRoute", true, "bool");
  let geojsonString = hasRouteQueryParam ? null : options.get("geojsonString");
  let initialRoutes = hasRouteQueryParam
    ? []
    : options.get("sportsRoutes", null, "object");
  let SelectedMapStyle = getSelectedMapStyle(PosterStyle);
  let geojsonUrl = options.get("geojsonUrl");
  let AcrylBlock = options.get("acrylBlock", "black");
  let AluminiumColor = options.get("aluminiumColor", "silver");
  let GiftCardText = "";
  let outlineFactor = 2;

  window.PosterStyle = String(PosterStyle);
  window.PosterKader = String(PosterKader);
  window.PosterOrientation = String(PosterOrientation);

  const CoordinatesInput = $("#coordinates-input");
  const CoordinatesLabel = $(".labels .coordinates");
  const MainTextInput = $("#location-input");
  const MainTextLabel = $(".labels .headline");
  const SubtitleInput = $("#subtitle-input");
  const SubtitleLabel = $(".labels .subtitle");
  const Subtitle2Input = $("#subtitle-2-input");
  const Subtitle2Label = $(".labels .subtitle-2");
  const PosterWrapper = $(".map-wrapper");
  const PosterSizeSelect = $(".js-poster-size");
  const PosterStyleSelect = $(".js-poster-style");
  const PosterFrameSelect = $(".js-poster-frame");
  const RouteColorInput = $(".js-route-color");
  const StartColorInput = $(".js-start-color");
  const EndColorInput = $(".js-end-color");
  const PosterKaderSelect = $(".js-poster-kader");
  const PosterGiftwrapSelect = $(".js-giftwrap");
  const GiftCardSelect = $(".js-giftcard");
  const CenterRouteButton = $(".js-center-route");
  const RouteThicknessInput = $(".js-thickness-input");
  const PosterOrientationSelect = $(".js-poster-orientation");
  const routesList = $(".js-sports-routes");
  const LockMapIcon = $(".js-lock-map-icon");
  const PrintTypeSelect = $(".js-print-type");
  const PrintStandUI = $(".acryl-block");
  const PosterFrameUI = $(".poster-frame");

  const debugReporter = DebugReporter({
    ajaxUrl: woocommerceUrl + "/wp-json/wallable/v1/client-diagnostics",
    containerSelector: ".js-notifications",
    shouldShow: ({ meta }) =>
      meta?.action === "add-to-cart" || meta?.action === "add-poster-order",
    extraContext: () => ({
      builder: $("body").attr("id"),
    }),
  }).init();

  // For fetching routes
  async function fetchStoredRoutes(forceRefresh = false) {
    if (forceRefresh) {
      routesLoadPromise = null;
    }

    if (routesLoadPromise) {
      return routesLoadPromise;
    }

    const requestUrl = new URL(routesApiUrl);

    requestUrl.searchParams.set("_routes_version", Date.now().toString());

    routesLoadPromise = fetch(requestUrl.toString(), {
      method: "GET",
      mode: "cors",
      credentials: "omit",
      cache: "no-store",
      headers: {
        Accept: "application/json",
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          throw new Error(`Routes API gaf status ${response.status}`);
        }

        const payload = await response.json();

        const routes = Array.isArray(payload) ? payload : payload?.routes;

        if (!Array.isArray(routes)) {
          throw new Error("Routes API bevat geen geldige routes-array.");
        }

        sportsRoutes = { routes };

        return sportsRoutes;
      })
      .catch((error) => {
        routesLoadPromise = null;
        throw error;
      });

    return routesLoadPromise;
  }

  async function initializeStoredRoutes() {
    try {
      if (routeQueryParam !== null) {
        await fetchStoredRoutes();
      }
      await getRouteFromQuery();
    } catch (error) {
      signal.throwIfAborted();
      console.warn(
        "Route niet beschikbaar; open de kaart zonder route.",
        error,
      );
      clearRoutes();
      // Saved designs already have their text. URL-selected routes do not.
      if (hasRouteQueryParam) setDefaultRouteText();
      renderRouteOptionsUI();
      renderRoutesOnMap();
      showRouteError(
        t("errors.routeUnavailable"),
      );
    }
    await waitForSportsmapPreview({
      map,
      signal,
      prepareLayout: async () => {
        await document.fonts.ready;
        signal.throwIfAborted();
        resizePosterWrapper();
        scaleFontSize();
        // Finish the wrapper's scale transition while the design is hidden.
        const wrapper = document.querySelector(".poster-wrapper");
        await Promise.all(
          (wrapper?.getAnimations() || []).map((animation) =>
            animation.finished.catch(() => {}),
          ),
        );
      },
      finalizeLayers: updateRouteLayerOrder,
    });
    signal.throwIfAborted();
    routesInitializationComplete = true;
    initialDesignSnapshot = createDesignSnapshot();
    showProductPreview();
    // The print renderer must capture the fully visible poster after its fade-in.
    await Promise.all(
      Array.from(document.querySelectorAll(".anim-wrapper")).flatMap(
        (element) =>
          element
            .getAnimations()
            .map((animation) => animation.finished.catch(() => {})),
      ),
    );
    signal.throwIfAborted();
    window.status = "mapbox-ready";
  }

  function showProductPreview() {
    $(".anim-wrapper").removeClass("hidden");
    $(".loading-wrapper").remove();
  }

  // Init map
  const map = new mapboxgl.Map({
    container: "map", // container ID
    style: SelectedMapStyle, // style URL
    center: mapCoordinates, // starting position [lng, lat]
    zoom: MapZoom, // starting zoom
    attributionControl: false,
    preserveDrawingBuffer: true,
    maxPitch: 0,
    maxZoom: 16,
  });

  // Mapbox removes all custom sources and layers whenever a style is loaded.
  // Always restore the current route store, including during saved-design startup.
  map.on("style.load", () => {
    renderRoutesOnMap(true);
  });

  map.on("movestart", (event) => {
    if (initialDesignSnapshot && event.originalEvent) {
      mapWasEdited = true;
    }
  });

  // Load saved poster
  getSavedPoster();
  toggleProductionEnv();
  calculatePosterPrice();
  resizePosterWrapper();
  toggleClearIcons();
  const startupPromise = initializeStoredRoutes();
  setPreviewMode();
  toggleMapInteractivity();
  updateLabelsOverRouteUI();

  // disable map rotation using right click + drag
  map.dragRotate.disable();

  // disable map rotation using touch rotation gesture
  map.touchZoomRotate.disableRotation();

  function toggleMapInteractivity() {
    if (unlockMap) {
      map.dragPan.enable();
      map.boxZoom.enable();
      map.keyboard.enable();
      map.doubleClickZoom.enable();
      map.scrollZoom.enable();
      map.touchZoomRotate.enable();
    } else {
      map.dragPan.disable();
      map.boxZoom.disable();
      map.keyboard.disable();
      map.doubleClickZoom.disable();
      map.scrollZoom.disable();
      map.touchZoomRotate.disable();
    }
  }

  // Listen to map input
  map.on("idle", () => {
    scaleFontSize();

    mapCoordinates = map.getCenter();
    MapZoom = map.getZoom();
  });

  // Center the route
  CenterRouteButton.on(
    "click",
    debounce(function () {
      mapWasEdited = true;
      centerRoute();
    }, 300),
  );

  function debounce(func, delay) {
    let timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(func, delay);
    };
  }

  // Input listeners
  $("input.form-control, textarea.form-control").on("input", function (e) {
    const posterLabel = e.currentTarget.dataset.posterLabel;
    const userInput = $(this).val();

    $(".labels ." + posterLabel).html(userInput);

    checkSpecialChars($(this), userInput);

    if (posterLabel === "headline") {
      scaleFontSize();
    }
  });

  // Listen to change and show clear icon
  $("input.form-control, textarea.form-control").on("change", function (e) {
    let posterLabel = e.currentTarget.dataset.posterLabel;
    let userInput = $(this).val();
    if (userInput === "") {
      $('.js-clear-input[data-field-id="' + posterLabel + '"]').hide();
    } else {
      $('.js-clear-input[data-field-id="' + posterLabel + '"]').show();
    }
    checkSpecialChars($(this), userInput);
  });

  // Listen to change and show clear icon
  RouteThicknessInput.on("input change", function (e) {
    const v = parseInt($(this).val(), 10);
    if (!Number.isNaN(v)) {
      routeThickness = v;
      routeStore.forEach((route) => {
        updateRoute(route.id, { style: { thickness: v } });
      });
      renderRoutesOnMap();
    }
  });

  // Clear input fields
  $(".js-clear-input").on("click", function (e) {
    let field = $(this).data("field-id");

    if (field === "search-list") {
      $('input.form-control[data-poster-label="' + field + '"]')
        .val("")
        .trigger("focus");
      loadStoredRoutes();
    } else {
      $(
        'input.form-control[data-poster-label="' +
          field +
          '"], textarea.form-control[data-poster-label="' +
          field +
          '"]',
      )
        .val("")
        .trigger("focus");
      $('.js-clear-input[data-field-id="' + field + '"]').hide();
      $(".labels ." + field).html("");
    }
  });

  // Check if ß is present
  function checkSpecialChars(input, userInput) {
    if (userInput.includes("ß")) {
      userInput = userInput.replace(/ß/g, "ss");
      input.val(userInput);
    }
  }

  // Toggle map interactivity
  $(document).on("click", ".js-unlock-map", function () {
    unlockMap = !unlockMap;

    unlockMap
      ? (LockMapIcon.addClass("fa-lock-open").removeClass("fa-lock"),
        $(".center-pin-wrapper").removeClass("d-none"))
      : (LockMapIcon.addClass("fa-lock").removeClass("fa-lock-open"),
        $(".center-pin-wrapper").addClass("d-none"));

    toggleMapInteractivity();
  });

  // Label over route toggle
  $(document).on("click", ".js-labels-over-route", function () {
    labelsOverRoute = !labelsOverRoute;

    if (map.isStyleLoaded()) {
      updateRouteLayerOrder();
    } else {
      map.once("idle", updateRouteLayerOrder);
    }

    updateLabelsOverRouteUI();
  });

  function updateLabelsOverRouteUI() {
    const icon = $(".js-labels-over-route-icon");

    if (labelsOverRoute) {
      icon.addClass("fa-check");
    } else {
      icon.removeClass("fa-check");
    }
  }

  function updateRouteLayerOrder() {
    if (!map.isStyleLoaded()) {
      map.once("idle", updateRouteLayerOrder);
      return;
    }

    const style = map.getStyle();

    if (!style?.layers?.length) {
      return;
    }

    const routeLayers = [
      routeCasingID,
      routeLineID,
      markerOutlineID,
      markerBorderID,
      markerFillID,
    ];

    const existingLayers = routeLayers.filter((id) => map.getLayer(id));

    if (!existingLayers.length) {
      return;
    }

    if (labelsOverRoute) {
      const firstTextLabelLayer = style.layers.find((layer) => {
        return (
          layer.type === "symbol" && layer.layout && layer.layout["text-field"]
        );
      });

      if (firstTextLabelLayer) {
        existingLayers.forEach((id) => {
          if (map.getLayer(id)) {
            map.moveLayer(id, firstTextLabelLayer.id);
          }
        });
      } else {
        // Geen labels gevonden: route gewoon bovenaan.
        existingLayers.forEach((id) => {
          if (map.getLayer(id)) {
            map.moveLayer(id);
          }
        });
      }
    } else {
      existingLayers.forEach((id) => {
        if (map.getLayer(id)) {
          map.moveLayer(id);
        }
      });
    }
  }

  // Check if field has value and show clear icon
  function toggleClearIcons() {
    const inputFields = $("input.form-control");

    inputFields.each(function () {
      const inputValue = $(this).val();

      if (inputValue.trim() === "") {
        let emptyField = $(this).data("poster-label");
        $('.js-clear-input[data-field-id="' + emptyField + '"]').hide();
      }
    });
  }

  $(".js-history-back").on("click", function () {
    history.back();
  });

  // Changing poster
  function setPosterSize(posterSize) {
    let posterColor;

    if (PosterStyle === "3") {
      posterColor = "black";
    } else {
      posterColor = "white";
    }
    PosterWrapper.removeClass().addClass(
      "map-wrapper " + posterColor + " size-" + posterSize + " " + PrintType,
    );
    resizePosterWrapper();
    map.resize();
  }

  // Change poster frame
  $(".js-frame-option").on("click", function () {
    PosterFrame = $(this).attr("data-frame");
    setFrameSelection(PosterFrame);
    setPosterFrame(PosterFrame);
    setGiftwrap(PosterFrame);
    calculatePosterPrice();
  });

  function setPosterFrame(PosterFrame) {
    const frameClasses = [
      "black-frame",
      "oak-frame",
      "white-frame",
      "tile black-frame",
      "tile oak-frame",
    ];

    PosterFrameUI.removeClass(frameClasses.join(" ") + " d-none");

    if (frameClasses.includes(PosterFrame + "-frame")) {
      PosterFrameUI.addClass(PosterFrame + "-frame");
    } else {
      PosterFrameUI.addClass("d-none");
    }
    resizePosterWrapper();
    activateGiftwrap();
  }

  function setFrameSelection(frame) {
    var selectedFrame = $('.js-frame-option[data-frame="' + frame + '"]');
    $(".js-frame-option").removeClass("active");
    selectedFrame.addClass("active");
  }

  // For setting border
  function setPosterKader(PosterKader) {
    window.PosterKader = PosterKader;
    if (PosterKader === "without") {
      $(".frame").addClass("d-none");
    } else {
      $(".frame").removeClass("d-none");
    }
  }

  // Add event listeners to custom zoom buttons
  $("#zoom-in").on("click", function () {
    mapWasEdited = true;
    var currentZoom = map.getZoom();
    map.easeTo({
      zoom: currentZoom + 1,
      duration: 500,
    });
  });

  $("#zoom-out").on("click", function () {
    mapWasEdited = true;
    var currentZoom = map.getZoom();
    map.easeTo({
      zoom: currentZoom - 1,
      duration: 500,
    });
  });

  // For scaling the font size
  function scaleFontSize() {
    const minFontSize = 3.95;
    const maxFontSize = 6.45;
    const lineBreakThreshold = 3.96;
    const text = $(".js-poster-headline");
    const textWrapper = $(".headline-wrapper");
    const parentWidth = textWrapper[0].getBoundingClientRect().width;

    let fontSize =
      parseFloat(text.css("font-size")) /
      parseFloat(text.parent().css("font-size")); // Get current font size in em

    // Subpixel-precieze breedte van de tekst
    function getTextWidth() {
      return text[0].getBoundingClientRect().width;
    }

    // Check of tekst smaller is dan parent (met marge)
    function canGrow() {
      return getTextWidth() + 1 < parentWidth && fontSize < maxFontSize;
    }

    // Check of tekst te breed is
    function isTextTooWide() {
      return getTextWidth() > parentWidth - 1;
    }

    // Eerst verkleinen indien nodig
    while (isTextTooWide() && fontSize > minFontSize) {
      fontSize -= 0.05;
      text.css("font-size", fontSize + "em");
    }

    // Daarna vergroten tot het nét past
    while (canGrow()) {
      fontSize += 0.05;
      text.css("font-size", fontSize + "em");
    }

    // Als tekst erg klein wordt, laten wrappen
    if (fontSize <= lineBreakThreshold) {
      text.css("white-space", "pre-wrap");
      return; // Stop verdere schaalacties
    } else {
      text.css("white-space", "nowrap");
    }
  }

  // Change poster font
  $(document).on("click", ".js-font-option", function () {
    FontStyle = $(this).attr("data-font");
    setPosterFontSelection(FontStyle);
    setPosterFontStyle(FontStyle);
    dismissSettingsPanel();

    setTimeout(() => {
      scaleFontSize();
    }, 50);
  });

  function setPosterFontStyle(font) {
    $(".poster-canvas .labels").removeClass("modern classic mono");
    $(".poster-canvas .labels").addClass(font);
  }

  function setPosterFontSelection(font) {
    var selectedFont = $('.js-font-option[data-font="' + font + '"]');
    $(".js-font-option").removeClass("active");
    selectedFont.addClass("active");
  }

  // Change poster size
  $(".js-size-option").on("click", function () {
    PosterSize = $(this).attr("data-size");
    setPosterSize(PosterSize);
    setSizeSelection(PosterSize);
    centerRoute();
    calculatePosterPrice();
  });

  function setSizeSelection(posterSize) {
    let selectedSize = $(
      '.js-toggle-for-material[data-material="' +
        PrintType +
        '"] .js-size-option[data-size="' +
        posterSize +
        '"]',
    );

    $(".js-size-option").removeClass("active");
    selectedSize.addClass("active");

    if (PrintType !== "paper") return;

    let framePrice = 0;
    let frameNormalPrice = 0;
    switch (posterSize) {
      case "small":
        framePrice = 15;
        frameNormalPrice = 21.95;
        break;
      case "medium":
        framePrice = 20;
        frameNormalPrice = 24.95;
        break;
      case "large":
        framePrice = 35;
        frameNormalPrice = 39.95;
        break;
      default:
        framePrice = 0;
        frameNormalPrice = 0;
    }

    // If extra-large, force no frame
    if (posterSize === "extra-large") {
      PosterFrame = "no-frame";
      setFrameSelection(PosterFrame);
      setPosterFrame(PosterFrame);
      $(".js-frame-option").addClass("disabled");
      $('.js-frame-option[data-frame="no-frame"]').removeClass("disabled");
      $("small[frame-normal-price]").text("-");
      $("small[frame-price]").hide();
    } else {
      $(".js-frame-option").removeClass("disabled");
      $("small[frame-price]").show();
      $("small[frame-price]").text(formatCurrency(framePrice));
      $("small[frame-normal-price]").text(formatCurrency(frameNormalPrice));

      $(".js-frame-option")
        .not('[data-frame="no-frame"]')
        .attr("data-price", framePrice.toFixed(2));
    }
  }

  // Change poster frame
  PosterFrameSelect.on("change", function () {
    PosterFrame = $(this).val();
    setPosterFrame(PosterFrame);
    setGiftwrap(PosterFrame);
    calculatePosterPrice();
  });

  // Change poster style
  $(".js-poster-kader").on("change", function () {
    PosterKader = $(this).val();
    setPosterKader(PosterKader);
    dismissSettingsPanel();
  });

  // Change map style
  PosterStyleSelect.on("change", function () {
    PosterStyle = $(this).val();
    fixRouteColor();
    setPosterStyle(PosterStyle);
    dismissSettingsPanel();
  });

  document.addEventListener("map-style-change", (event) => {
    PosterStyle = event.detail.posterStyle;
    window.PosterStyle = PosterStyle;
    fixRouteColor();
    setPosterStyle(PosterStyle);
    syncMapStyleSelector();
    syncKaderSelector();
  });

  document.addEventListener("kader-change", (event) => {
    PosterKader = event.detail.posterKader;
    window.PosterKader = PosterKader;
    setPosterKader(PosterKader);
    syncKaderSelector();
  });

  document.addEventListener("orientation-change", (event) => {
    PosterOrientation = event.detail.posterOrientation;
    window.PosterOrientation = PosterOrientation;
    setPosterOrientation(PosterOrientation);
    syncOrientationSelector();
    syncKaderSelector();
  });

  function syncMapStyleSelector() {
    document.querySelector("map-style-selector")?.setState({
      printType: PrintType,
      posterStyle: String(PosterStyle),
    });
  }

  function syncKaderSelector() {
    document.querySelector("kader-selector")?.setState({
      printType: PrintType,
      posterKader: String(PosterKader),
      posterOrientation: String(PosterOrientation),
    });
  }

  function syncOrientationSelector() {
    const selector = document.querySelector("orientation-selector");
    if (!selector) return;

    selector.classList.toggle("d-none", PrintType === "tegel");
    selector.setState({
      printType: PrintType,
      posterOrientation: String(PosterOrientation),
    });
  }

  function setPosterStyle(PosterStyle) {
    window.PosterStyle = String(PosterStyle);
    const printApp = $("#PrintApp");
    PosterWrapper.removeClass("black");
    printApp.removeClass("black");
    if (PosterStyle == 3) {
      PosterWrapper.addClass("black");
      printApp.addClass("black");
    }

    let prevSelectedMapStyle = SelectedMapStyle;
    SelectedMapStyle = getSelectedMapStyle(PosterStyle);

    if (prevSelectedMapStyle !== SelectedMapStyle) {
      map.setStyle(SelectedMapStyle);
    } else {
      renderRoutesOnMap();
    }
  }

  function getSelectedMapStyle(style) {
    let mapStyle;
    if (style == 4) {
      mapStyle = MapStyle4;
    } else if (style == 3) {
      mapStyle = MapStyle3;
    } else if (style == 2) {
      mapStyle = MapStyle2;
    } else {
      mapStyle = MapStyle1;
    }
    return mapStyle;
  }

  function fixRouteColor() {
    if (PosterStyle == 3 && routeColor === "#000000") {
      routeColor = "#ffffff";
    } else if (PosterStyle !== 3 && routeColor === "#ffffff") {
      routeColor = "#000000";
    }

    if (PosterStyle == 3 && endColor === "#000000") {
      endColor = "#ffffff";
    } else if (PosterStyle !== 3 && endColor === "#ffffff") {
      endColor = "#000000";
    }

    if (PosterStyle == 3 && startColor === "#000000") {
      startColor = "#ffffff";
    } else if (PosterStyle !== 3 && startColor === "#ffffff") {
      startColor = "#000000";
    }

    RouteColorInput.val(routeColor);
    EndColorInput.val(endColor);
    StartColorInput.val(startColor);

    routeStore.forEach((route) => {
      const style = { ...route.style };
      if (PosterStyle == 3) {
        if (style.color === "#000000") style.color = "#ffffff";
        if (style.startColor === "#000000") style.startColor = "#ffffff";
        if (style.endColor === "#000000") style.endColor = "#ffffff";
      } else {
        if (style.color === "#ffffff") style.color = "#000000";
        if (style.startColor === "#ffffff") style.startColor = "#000000";
        if (style.endColor === "#ffffff") style.endColor = "#000000";
      }
      updateRoute(route.id, { style });
    });
    renderRouteOptionsUI();
    renderRoutesOnMap();
  }

  // Change print type
  $(".js-print-option").on("click", function () {
    let SelectedPrintType = $(this).attr("data-print");
    const materialChanged = PrintType !== SelectedPrintType;

    if (materialChanged) {
      PrintType = SelectedPrintType;
      setPrintType(PrintType);
      setPosterStyle(PosterStyle);
      fixRouteColor();
    }
    if ($(this).hasClass("d-block")) {
      PrintTypeSelected = true;
    }
    togglePrintTypes();

    if (materialChanged && routeStore.size) {
      requestAnimationFrame(() => {
        map.resize();
        centerRoute();
      });
    }
  });

  $(document).on("click", ".js-show-print-types", function () {
    togglePrintTypes();
  });

  function setPrintType(PrintType) {
    var selectedPrint = $('.js-print-option[data-print="' + PrintType + '"]');
    $(".js-print-option").removeClass("active");
    $(".block-wrapper, body").removeClass("tegel");
    selectedPrint.addClass("active");

    // If acryl
    if (PrintType == "acryl") {
      if (PosterSize === "large" || PosterSize === "extra-large") {
        PosterSize = "small";
      }
      if (["3"].includes(PosterStyle)) {
        PosterStyle = 1;
        setPosterStyle(PosterStyle);
        PosterStyleSelect.val(PosterStyle);
      }
      PosterFrame = "no-frame";

      // If aluminium
    } else if (PrintType == "aluminium") {
      if (PosterSize === "large" || PosterSize === "extra-large") {
        PosterSize = "medium";
      }
      if (["3"].includes(PosterStyle)) {
        PosterStyle = 1;
        setPosterStyle(PosterStyle);
        PosterStyleSelect.val(PosterStyle);
      }
      PosterFrame = "no-frame";
      setAluminiumColor(AluminiumColor);

      // If Tegel
    } else if (PrintType == "tegel") {
      PosterSize = "small";
      PosterKader = "without";
      PosterOrientation = "portrait";
      if (["3"].includes(PosterStyle)) {
        PosterStyle = 1;
        setPosterStyle(PosterStyle);
        PosterStyleSelect.val(PosterStyle);
      }
      PosterKaderSelect.val(PosterKader);
      setPosterKader(PosterKader);
      setPosterOrientation(PosterOrientation);
      $(".block-wrapper, body").addClass("tegel");
      PosterFrame = "no-frame";

      // If paper
    } else {
      if (PosterSize === "xs") {
        PosterSize = "small";
      } else if (PosterSize === "extra-large") {
        PosterSize = "large";
      }
      AcrylBlock = "no-block";
    }
    togglePosterStyles();
    togglePosterKaders();
    toggleOrientationSelect();
    setStandSelection(AcrylBlock);
    setFrameSelection(PosterFrame);
    setPosterFrame(PosterFrame);
    setPosterSize(PosterSize);
    setSizeSelection(PosterSize);
    setPrintStand(AcrylBlock);
    calculatePosterPrice();
  }

  function togglePrintTypes() {
    if (PrintTypeSelected) {
      $(".js-print-option").hide();
      $(".js-toggle-for-material").hide();
      $(".js-show-print-types").show();
      $(".js-toggle-for-material[data-material='" + PrintType + "']").show();
      $(".js-print-option[data-print='" + PrintType + "']").show();
      PrintTypeSelected = false;
    } else {
      $(".js-print-option").show();
      $(".js-show-print-types").hide();
      $(".js-toggle-for-material").hide();
      PrintTypeSelected = true;
    }
  }

  function togglePosterStyles() {
    // Enable all options
    $(".js-poster-style option").each(function () {
      $(this).prop("disabled", false);
    });

    if (["aluminium", "acryl", "tegel"].includes(PrintType)) {
      $(".js-poster-style option").each(function () {
        if (["3"].includes($(this).val())) {
          $(this).prop("disabled", true);
        }
      });
    }
    syncMapStyleSelector();
  }

  function togglePosterKaders() {
    if (PrintType === "tegel") {
      $(".js-poster-kader").hide();
    } else {
      $(".js-poster-kader").show();
    }
    syncKaderSelector();
  }

  function toggleOrientationSelect() {
    if (PrintType === "tegel") {
      PosterOrientationSelect.hide();
    } else {
      PosterOrientationSelect.show();
    }
    syncOrientationSelector();
  }

  // Change aluminium color
  $(".js-color-option").on("click", function () {
    AluminiumColor = $(this).attr("data-color");
    setAluminiumColor(AluminiumColor);
    setAluminiumColorSelection(AluminiumColor);
    setMarkerOutlineAluminium();
  });

  function setAluminiumColor(color) {
    PosterWrapper.attr("data-aluminium-color", color);
  }

  function setAluminiumColorSelection(color) {
    var selectedColor = $('.js-color-option[data-color="' + color + '"]');
    $(".js-color-option").removeClass("active");
    selectedColor.addClass("active");
  }

  function setMarkerOutlineAluminium() {
    if (BuilderName === "PrintApp") {
      return;
    }

    let fillColor = "rgb(255,255,255)";

    if (PrintType === "aluminium") {
      const overlayColors = {
        silver: "220,218,219",
        gold: "223,207,170",
        bronze: "209,176,128",
        rose: "195,132,121",
      };

      fillColor = `rgb(${overlayColors[AluminiumColor] || "255,255,255"})`;
    }

    if (map.getLayer(markerBorderID)) {
      map.setPaintProperty(markerBorderID, "circle-color", fillColor);
    }

    if (PosterStyle === "1" || PosterStyle === "2") {
      if (map.getLayer("settlement-major-label")) {
        map.setPaintProperty(
          "settlement-major-label",
          "text-halo-color",
          fillColor,
        );
      }
      if (map.getLayer("settlement-minor-label")) {
        map.setPaintProperty(
          "settlement-minor-label",
          "text-halo-color",
          fillColor,
        );
      }
      if (map.getLayer(routeCasingID)) {
        map.setPaintProperty(routeCasingID, "line-color", fillColor);
      }
    }
  }

  // Change print stand
  $(document).on("click", ".js-block-option", function () {
    AcrylBlock = $(this).attr("data-block");
    setStandSelection(AcrylBlock);
    setPrintStand(AcrylBlock);
    calculatePosterPrice();
  });

  function setStandSelection(AcrylBlock) {
    var selectedBlock = $('.js-block-option[data-block="' + AcrylBlock + '"]');
    $(".js-block-option").removeClass("active");
    selectedBlock.addClass("active");
  }

  function setPrintStand(AcrylBlock) {
    const isBlackBlock = AcrylBlock === "black";
    const isOakBlock = AcrylBlock === "oak";
    const hasBlock = isBlackBlock || isOakBlock;

    const isBlackFrame = AcrylBlock === "black-frame";
    const isOakFrame = AcrylBlock === "oak-frame";
    const hasFrame = isBlackFrame || isOakFrame;

    PosterWrapper.attr("data-perspective", hasBlock);

    if (hasFrame) {
      PrintStandUI.addClass("d-none");
      PosterFrameUI.removeClass("d-none");
      if (isBlackFrame) {
        setPosterFrame("tile black");
      } else if (isOakFrame) {
        setPosterFrame("tile oak");
      }
    } else if (hasBlock) {
      PrintStandUI.removeClass("black oak d-none");
      PosterFrameUI.addClass("d-none");

      if (isBlackBlock) {
        PrintStandUI.addClass("black");
      } else if (isOakBlock) {
        PrintStandUI.addClass("oak");
      } else {
        PrintStandUI.addClass("d-none");
      }

      PrintStandUI.toggleClass("hide-shadow", PrintType === "tegel");
    } else {
      if (PrintType !== "paper") {
        PosterFrameUI.addClass("d-none");
      }
      PrintStandUI.addClass("d-none");
    }
  }

  // Change poster orientation
  $(".js-poster-orientation").on("change", function () {
    PosterOrientation = $(this).val();
    setPosterOrientation(PosterOrientation);
    dismissSettingsPanel();
  });

  function setPosterOrientation(orientation) {
    window.PosterOrientation = orientation;
    if (orientation === "landscape") {
      $(".poster-wrapper").addClass("landscape");
    } else {
      $(".poster-wrapper").removeClass("landscape");
    }
    resizePosterWrapper();
    map.resize();
    centerRoute();
  }

  // Change marker color
  RouteColorInput.on("input", function () {
    routeColor = $(this).val();
    routeStore.forEach((route) => {
      updateRoute(route.id, { style: { color: routeColor } });
    });
    renderRoutesOnMap();
  });

  function getMarkerBorderColor() {
    if (PrintType === "aluminium") {
      const colors = {
        silver: "rgb(220,218,219)",
        gold: "rgb(223,207,170)",
        bronze: "rgb(209,176,128)",
        rose: "rgb(195,132,121)",
      };

      return colors[AluminiumColor] || "rgb(255,255,255)";
    }

    if (PosterStyle == 3) {
      return "rgb(0,0,0)";
    }

    if (PrintType === "tegel") {
      return "rgb(244,244,246)";
    }

    return "rgb(255,255,255)";
  }

  function changeRouteMarkerColor() {
    if (map.getLayer(markerOutlineID)) {
      map.setPaintProperty(markerOutlineID, "circle-color", [
        "coalesce",
        ["get", "routeColor"],
        routeColor,
      ]);
    }

    if (map.getLayer(markerFillID)) {
      map.setPaintProperty(markerFillID, "circle-color", [
        "coalesce",
        ["get", "color"],
        routeColor,
      ]);
    }
  }

  StartColorInput.on("input", function () {
    startColor = $(this).val();
    routeStore.forEach((route) => {
      updateRoute(route.id, { style: { startColor } });
    });
    renderRoutesOnMap();
  });

  EndColorInput.on("input", function () {
    endColor = $(this).val();
    routeStore.forEach((route) => {
      updateRoute(route.id, { style: { endColor } });
    });
    renderRoutesOnMap();
  });

  // Toggle giftwrap
  $(".js-giftwrap").on("change", function () {
    calculatePosterPrice();
  });

  function activateGiftwrap() {
    if (PrintType === "paper" && PosterFrame === "no-frame") {
      PosterGiftwrapSelect.val("false");
      $(".js-giftwrap option[value=true]")
        .attr("disabled", "disabled")
        .siblings()
        .removeAttr("disabled");
    } else {
      $(".js-giftwrap option[value=true]").removeAttr("disabled");
    }
  }

  function setGiftwrap(PosterFrame) {
    if (PosterFrame === "no-frame") {
      PosterGiftwrapSelect.val("false");
      $(".js-giftwrap option[value=true]")
        .attr("disabled", "disabled")
        .siblings()
        .removeAttr("disabled");
    } else {
      $(".js-giftwrap option[value=true]").removeAttr("disabled");
    }
  }

  // Change giftcard text
  $(".js-giftcard").on("change", function () {
    if ($(this).val() === "true") {
      $(".js-giftcard-text").show();
      GiftCardText = $(".js-giftcard-text").val();
    } else {
      $(".js-giftcard-text").hide();
      GiftCardText = "";
    }
    calculatePosterPrice();
  });

  $(".js-giftcard-text").on("change", function () {
    GiftCardText = $(this).val();
  });

  // Change upload
  $(".js-gpx-upload").on("change", async function (event) {
    const files = Array.from(event.target.files || []);
    for (const file of files) {
      await readFile(file, true, {
        name: file.name,
        source: { type: "upload" },
      });
    }
    event.target.value = "";
  });

  async function readFile(file, newRoute, routeOptions = {}) {
    if (!file) return null;

    try {
      const fileData = await file.text();
      const routeGeojson = parseRouteData(fileData);
      return addRouteToBuilder(routeGeojson, {
        ...routeOptions,
        prefillText: newRoute,
        center: true,
      });
    } catch (error) {
      console.error("Routebestand kon niet worden ingeladen:", error);
      showRouteError(
        t("sportsmap.errors.routeFileFailed", {
          name: routeOptions.name || t("sportsmap.routeFile"),
        }),
      );
      return null;
    }
  }

  function parseRouteData(fileData) {
    const normalizedData = String(fileData || "").trim();
    let geojson;

    if (normalizedData.startsWith("{") || normalizedData.startsWith("[")) {
      geojson = JSON.parse(normalizedData);
    } else {
      const parser = new DOMParser();
      const gpxDocument = parser.parseFromString(normalizedData, "text/xml");
      if (gpxDocument.getElementsByTagName("parsererror").length) {
        throw new Error("Ongeldig GPX/XML-bestand");
      }
      geojson = converter.gpx(gpxDocument);
    }

    const routeGeojson = normalizeRouteGeojson(geojson);
    if (!routeGeojson.features.length) {
      throw new Error("Geen LineString of MultiLineString route gevonden.");
    }
    return routeGeojson;
  }

  function normalizeRouteGeojson(geojson) {
    const features =
      geojson.type === "FeatureCollection"
        ? geojson.features
        : geojson.type === "Feature"
          ? [geojson]
          : [
              {
                type: "Feature",
                geometry: geojson,
                properties: {},
              },
            ];

    const routeFeatures = features
      .filter((f) => f.geometry)
      .flatMap((f) => {
        if (f.geometry.type === "LineString") {
          return [f];
        }

        if (f.geometry.type === "MultiLineString") {
          return f.geometry.coordinates.map((coordinates) => ({
            type: "Feature",
            geometry: {
              type: "LineString",
              coordinates,
            },
            properties: f.properties || {},
          }));
        }

        return [];
      });

    return {
      type: "FeatureCollection",
      features: routeFeatures.map((f) => ({
        type: "Feature",
        geometry: {
          type: "LineString",
          coordinates: f.geometry.coordinates,
        },
        properties: f.properties || {},
      })),
    };
  }

  async function loadDefaultRoute(fileURL, routeOptions = {}) {
    if (!fileURL) {
      if (!routesInitializationComplete)
        throw new Error("Route-URL ontbreekt.");
      return null;
    }

    try {
      const response = await fetch(fileURL, { cache: "no-store" });
      if (!response.ok) {
        throw new Error(`Route gaf status ${response.status}`);
      }
      const routeGeojson = parseRouteData(await response.text());
      return addRouteToBuilder(routeGeojson, routeOptions);
    } catch (error) {
      console.error("Error fetching file:", error);
      if (!routesInitializationComplete) throw error;
      showRouteError(t("errors.routeUnavailable"));
      return null;
    }
  }

  function loadRoute(geojson, prefillText, routeOptions = {}) {
    if (process.env.USE_CART === "false") {
      console.log("Route Object: ", geojson);
    }

    if (geojson === "" || geojson === "null" || !geojson) {
      return null;
    }

    const geojsonObject = normalizeRouteGeojson(
      typeof geojson === "string" ? JSON.parse(geojson) : geojson,
    );
    return addRouteToBuilder(geojsonObject, {
      ...routeOptions,
      prefillText,
      center: BuilderName !== "PrintApp",
    });
  }

  function addRouteToBuilder(
    geojson,
    {
      name,
      source,
      style,
      geojsonUrl,
      prefillText = false,
      center = false,
    } = {},
  ) {
    const route = addRoute({
      name: name || getRouteName(geojson),
      geojson,
      geojsonUrl: geojsonUrl || null,
      source: source || { type: "upload" },
      style: {
        color: routeColor,
        thickness: routeThickness,
        startColor,
        endColor,
        showStartPoint: showEndPoints,
        showEndPoint: showEndPoints,
        ...(style || {}),
      },
    });

    geojsonString = null;
    renderRouteOptionsUI();
    renderRoutesOnMap();

    if (prefillText && BuilderName !== "PrintApp") {
      prefillRouteText(geojson);
      scaleFontSize();
    }

    if (center && BuilderName !== "PrintApp") {
      map.once("idle", () => centerRoute());
    }

    return route;
  }

  function getRouteName(geojson) {
    return (
      geojson?.features?.find((feature) => feature?.properties?.name)
        ?.properties?.name || t("sportsmap.genericRouteName")
    );
  }

  function renderRoutesOnMap(styleIsReady = false) {
    if (!styleIsReady && !map.isStyleLoaded()) {
      map.once("idle", () => renderRoutesOnMap(true));
      return;
    }

    const routesGeojson = buildRoutesGeojson();
    if (!routesGeojson.features.length) {
      removeRouteMapData();
      return;
    }

    let casingColor = "#ffffff";
    if (PosterStyle == 3) {
      casingColor = "#000000";
    }

    const routeSource = map.getSource(routesWrapper);
    const routeLayersExist =
      map.getLayer(routeCasingID) && map.getLayer(routeLineID);

    if (routeSource && routeLayersExist) {
      // Updating an existing source is atomic and avoids races while batch uploads load.
      routeSource.setData(routesGeojson);
      map.setPaintProperty(routeCasingID, "line-color", casingColor);
      updateRouteMarkers(buildRouteEndpointsGeojson());
      scheduleRouteLayerOrderUpdate();
      return;
    }

    // A style change may leave only part of the previous source/layer set behind.
    removeRouteMapData();

    map.addSource(routesWrapper, { type: "geojson", data: routesGeojson });

    map.addLayer({
      id: routeCasingID,
      type: "line",
      source: routesWrapper,
      layout: {
        "line-cap": "round",
        "line-join": "round",
      },
      paint: {
        "line-color": casingColor,
        "line-width": [
          "*",
          ["coalesce", ["get", "thickness"], routeThickness],
          outlineFactor,
        ],
        "line-opacity": 0.8,
      },
    });

    map.addLayer({
      id: routeLineID,
      type: "line",
      source: routesWrapper,
      layout: {
        "line-cap": "round",
        "line-join": "round",
      },
      paint: {
        "line-color": ["coalesce", ["get", "color"], routeColor],
        "line-width": ["coalesce", ["get", "thickness"], routeThickness],
        "line-opacity": 1,
      },
    });

    updateRouteMarkers(buildRouteEndpointsGeojson());
    scheduleRouteLayerOrderUpdate();
  }

  function scheduleRouteLayerOrderUpdate() {
    map.once("idle", updateRouteLayerOrder);
  }

  function removeRouteMapData() {
    removeRouteMarkers();
    [routeLineID, routeCasingID].forEach(
      (id) => map.getLayer(id) && map.removeLayer(id),
    );
    if (map.getSource(routesWrapper)) map.removeSource(routesWrapper);
  }

  function removeRouteMarkers() {
    [markerFillID, markerBorderID, markerOutlineID].forEach(
      (id) => map.getLayer(id) && map.removeLayer(id),
    );
    if (map.getSource(markerSourceID)) map.removeSource(markerSourceID);
  }

  function centerRoute() {
    const coordinates = Array.from(routeStore.values()).flatMap(
      getRouteCoordinates,
    );

    if (coordinates.length > 0) {
      const bounds = coordinates.reduce(
        (bounds, coordinate) => {
          return bounds.extend(coordinate);
        },
        new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]),
      );

      map.fitBounds(bounds, {
        padding: routeCameraPadding,
        animate: false,
      });
    }
  }

  function addRouteMarkers(endpointGeojson) {
    if (!endpointGeojson?.features?.length) return;

    map.addSource(markerSourceID, {
      type: "geojson",
      data: endpointGeojson,
    });

    // 1. Buitenste rand
    map.addLayer({
      id: markerOutlineID,
      type: "circle",
      source: markerSourceID,
      paint: {
        "circle-radius": 13,
        "circle-color": ["coalesce", ["get", "routeColor"], routeColor],
      },
    });

    // 2. Witte/tussenliggende rand
    map.addLayer({
      id: markerBorderID,
      type: "circle",
      source: markerSourceID,
      paint: {
        "circle-radius": 9,
        "circle-color": getMarkerBorderColor(),
      },
    });

    // 3. Binnenste cirkel
    map.addLayer({
      id: markerFillID,
      type: "circle",
      source: markerSourceID,
      paint: {
        "circle-radius": 6,
        "circle-color": ["coalesce", ["get", "color"], routeColor],
      },
    });
  }

  function updateRouteMarkers(endpointGeojson) {
    if (!endpointGeojson?.features?.length) {
      removeRouteMarkers();
      return;
    }

    const markerSource = map.getSource(markerSourceID);
    const markerLayersExist =
      map.getLayer(markerOutlineID) &&
      map.getLayer(markerBorderID) &&
      map.getLayer(markerFillID);

    if (markerSource && markerLayersExist) {
      markerSource.setData(endpointGeojson);
      map.setPaintProperty(
        markerBorderID,
        "circle-color",
        getMarkerBorderColor(),
      );
      return;
    }

    removeRouteMarkers();
    addRouteMarkers(endpointGeojson);
  }

  function renderRouteOptionsUI() {
    const container = document.getElementById("routeOptionsContainer");
    if (!container) return;
    $(".js-route-options-title").toggleClass("d-none", routeStore.size === 0);
    container.innerHTML = "";
    const openSingleRouteSettings = routeStore.size === 1;

    routeStore.forEach((route) => {
      const element = document.createElement("route-options");
      element.route = route;
      element.settingsOpen = openSingleRouteSettings;
      container.appendChild(element);
    });
  }

  document.addEventListener("sportsmap-route-change", (event) => {
    updateRoute(event.detail.id, { style: event.detail.style });
    renderRoutesOnMap();
  });

  document.addEventListener("sportsmap-route-remove", (event) => {
    removeRoute(event.detail.id);
    renderRouteOptionsUI();
    renderRoutesOnMap();
    if (routeStore.size) centerRoute();
  });

  function showRouteError(message) {
    if (BuilderName === "PrintApp") return;
    $("<div>", {
      class: "js-error alert alert-danger text-center p-2",
      text: message,
    }).appendTo(".js-notifications");
  }

  function prefillRouteText(geojson) {
    // Fill event name
    const eventName = geojson.features[0].properties.name;

    if (eventName && eventName.length > 0) {
      MainTextInput.val(eventName.replace(/ß/g, "ss"));
      MainTextLabel.html(eventName.replace(/ß/g, "ss"));
    }

    // Fill date and length
    const length = Array.from(routeStore.values())
      .reduce(
        (total, route) =>
          total + turf.length(route.geojson, { units: "kilometers" }),
        0,
      )
      .toFixed(2)
      .replace(".", ",");
    const timestamp = geojson.features[0].properties.time;
    let subLabel = length + " KM";

    if (timestamp) {
      const date = new Date(timestamp);

      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
      };

      const dutchDate = date.toLocaleDateString("nl-NL", options);
      subLabel = dutchDate + " / " + subLabel;
    }

    SubtitleLabel.html(subLabel);
    SubtitleInput.val(subLabel);
  }

  // For searching the routes list
  $("input.js-search-event").on("input", function (e) {
    clearTimeout(searchTimer);

    const query = this.value;

    searchTimer = setTimeout(() => {
      handleSearch(query);
      if ($(this).val() === "") {
        $('.js-clear-input[data-field-id="search-list"]').hide();
      } else {
        $('.js-clear-input[data-field-id="search-list"]').show();
      }
    }, 150);
  });

  function createRouteCard(route) {
    const hasRouteImage =
      typeof route.imgUrl === "string" && route.imgUrl.trim() !== "";

    const routeImage = hasRouteImage
      ? route.imgUrl.trim()
      : routePlaceholderImage;

    const imageAttributes = hasRouteImage
      ? `
      src="${routePlaceholderImage}"
      data-src="${routeImage}"
      class="card-img-top js-lazy-route-img"
    `
      : `
      src="${routePlaceholderImage}"
      class="card-img-top"
    `;

    const yearBadge = route.year
      ? `<div class="badge" data-year="${route.year}">${route.year}</div>`
      : "";

    return `
    <div class="col">
      <div
        class="card h-100 cursor-pointer js-load-pred-route"
        data-route-id="${route.id}"
      >
        ${yearBadge}

        <img
          ${imageAttributes}
          loading="lazy"
          alt="${route.name || t("sportsmap.defaultRouteName")}"
          onerror="this.onerror=null;this.src='${routePlaceholderImage}';"
        >

        <div class="card-body">
          <h6 class="card-title mb-0">${route.name || ""}</h6>
        </div>
      </div>
    </div>
  `;
  }

  async function handleSearch(inputVal) {
    const query = inputVal.trim();

    if (query === "") {
      await loadStoredRoutes();
      return;
    }

    const match = searchRoutes(query).sort(
      (a, b) => Number(b.timestamp || 0) - Number(a.timestamp || 0),
    );

    if (match.length !== 0) {
      const html = match.map(createRouteCard).join("");

      routesList.html(html);

      initRoutesList();
      initLazyRouteImages();
    } else {
      routesList.html(
        `<p class="text-center w-100">${t("sportsmap.routesModal.noResults")}</p>`,
      );
    }
  }

  function searchRoutes(query) {
    // Convert the query to lowercase for case-insensitive search
    query = query.toLowerCase();

    return (sportsRoutes.routes || []).filter((route) => {
      const { name, event, location, subtitle } = route;
      const searchableText =
        `${name} ${event} ${location} ${subtitle}`.toLowerCase();

      return searchableText.includes(query);
    });
  }

  // Calculate poster price
  function calculatePosterPrice() {
    const getPrice = (selector) =>
      parseFloat($(selector).find(".active, :selected").attr("data-price")) ||
      0;

    // Scope material-specific selectors to only the visible material
    const activeMaterialDiv = `.js-toggle-for-material[data-material="${PrintType}"]`;

    const subtotalPrice =
      getPrice(`${activeMaterialDiv} .js-poster-size`) +
      getPrice(`${activeMaterialDiv} .js-acryl-block`) +
      getPrice(PosterFrameSelect) +
      getPrice(PosterGiftwrapSelect) +
      getPrice(GiftCardSelect);

    $(".subtotal").text(formatCurrency(subtotalPrice));
  }

  // Get list of stored routes
  async function loadStoredRoutes() {
    routesList.html("");

    try {
      await fetchStoredRoutes();
    } catch (error) {
      console.error("Routes konden niet worden geladen:", error);

      routesList.html(
        '<div class="alert alert-danger text-center w-100">' +
            t("errors.routesUnavailable") +
          "</div>",
      );

      return;
    }

    const sortedRoutes = [...(sportsRoutes.routes || [])].sort(
      (a, b) => Number(b.timestamp || 0) - Number(a.timestamp || 0),
    );

    const html = sortedRoutes
      .filter((route) => Number(route.id) !== 0)
      .map(createRouteCard)
      .join("");

    routesList.html(html);

    initRoutesList();
    initLazyRouteImages();
  }

  function initRoutesList() {
    $(".js-load-pred-route").on("click", function () {
      loadStoredRoute($(this).data("route-id"));
      RoutesModal.hide();
      setTimeout(() => {
        dismissSettingsPanel();
      }, 500);
    });
  }

  function initLazyRouteImages() {
    const images = document.querySelectorAll(".js-lazy-route-img[data-src]");

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const img = entry.target;
          img.src = img.dataset.src;
          img.removeAttribute("data-src");
          obs.unobserve(img);
        });
      },
      {
        root: document.querySelector("#routes-modal .modal-body"),
        rootMargin: "200px",
      },
    );

    images.forEach((img) => observer.observe(img));
  }

  async function loadStoredRoute(routeID) {
    if (routeID === null) return false;
    const normalizedRouteID = Number(routeID);

    const route = (sportsRoutes.routes || []).find(
      (item) => Number(item.id) === normalizedRouteID,
    );

    if (!route) {
      return false;
    }

    let routeUrl;

    try {
      routeUrl = new URL(route.url, woocommerceUrl);

      if (route.timestamp) {
        routeUrl.searchParams.set("v", String(route.timestamp));
      }
    } catch (error) {
      if (!routesInitializationComplete) throw error;
      console.error("Ongeldige route-URL:", route.url, error);
      return;
    }

    // An archive selection replaces the current route set instead of being
    // appended like a GPX/GeoJSON upload.
    clearRoutes();
    renderRouteOptionsUI();
    renderRoutesOnMap();

    await loadDefaultRoute(routeUrl.toString(), {
      name: route.name || t("sportsmap.defaultRouteName"),
      source: {
        type: "archive",
        routeId: normalizedRouteID,
        name: route.name || "",
        event: route.event || "",
        location: route.location || "",
        year: route.year || "",
      },
      center: BuilderName !== "PrintApp",
    });

    MainTextLabel.html(route.location);
    MainTextInput.val(route.location);

    SubtitleLabel.html(route.subtitle);
    SubtitleInput.val(route.subtitle);

    Subtitle2Label.html(route.subtitle2);
    Subtitle2Input.val(route.subtitle2);

    CoordinatesLabel.html(route.event);
    CoordinatesInput.val(route.event);

    setPageTitle();
    return true;
  }

  function setDefaultRouteText() {
    MainTextLabel.html(t("sportsmap.defaults.location"));
    MainTextInput.val(t("sportsmap.defaults.location"));
    SubtitleLabel.html(t("sportsmap.defaults.dateDistance"));
    SubtitleInput.val(t("sportsmap.defaults.dateDistance"));
    Subtitle2Label.html(t("sportsmap.defaults.nameTime"));
    Subtitle2Input.val(t("sportsmap.defaults.nameTime"));
    CoordinatesLabel.html(t("sportsmap.defaults.achievement"));
    CoordinatesInput.val(t("sportsmap.defaults.achievement"));
    setPageTitle();
  }

  // For getting predefined route from url var
  async function getRouteFromQuery() {
    if (hasRouteQueryParam) {
      clearRoutes();
      const routeLoaded = await loadStoredRoute(routeQueryParam);
      if (routeLoaded) {
        dismissSettingsPanel();
      } else {
        // An invalid shared URL still opens a usable product without a route.
        setDefaultRouteText();
      }
    } else if (Array.isArray(initialRoutes) && initialRoutes.length) {
      await hydrateConfiguredRoutes(initialRoutes);
    } else if (geojsonUrl) {
      clearRoutes();
      await loadDefaultRoute(geojsonUrl, {
        name: t("sportsmap.genericRouteName"),
      });
    } else if (geojsonString) {
      clearRoutes();
      loadRoute(geojsonString, false, {
        name: t("sportsmap.genericRouteName"),
      });
    } else {
      clearRoutes();
    }

    renderRouteOptionsUI();
    renderRoutesOnMap();

    // Camera padding is part of the visible composition created by
    // centerRoute(). Apply it in both the print renderer and the editor when
    // an existing config is opened, so the saved center/zoom render equally.
    if (BuilderName === "PrintApp" || hasConfigFileUrl) {
      map.once("idle", () => {
        map.jumpTo({
          center: mapCoordinates,
          zoom: MapZoom,
          padding: routeCameraPadding,
        });
      });
    }
  }

  async function hydrateConfiguredRoutes(routes) {
    clearRoutes();

    const hydrated = await Promise.all(
      routes.map(async (route) => {
        if (route.geojson) {
          return { ...route, geojson: normalizeRouteGeojson(route.geojson) };
        }

        if (!route.geojsonUrl) {
          throw new Error(
            `Route ${route.name || route.id} heeft geen GeoJSON-URL.`,
          );
        }

        const response = await fetch(route.geojsonUrl, { cache: "no-store" });
        if (!response.ok) {
          throw new Error(
            `Route ${route.name || route.id} gaf status ${response.status}.`,
          );
        }

        return {
          ...route,
          geojson: parseRouteData(await response.text()),
        };
      }),
    );

    loadRoutes(hydrated);
  }

  // For settingp page title dynamically
  function setPageTitle() {
    let title =
      "Sportsmap builder 💪 - " +
      MainTextLabel.html() +
      " " +
      CoordinatesLabel.html();
    $("title").text(title);
  }

  // Create poster preview image
  async function createPosterPreview() {
    $(".poster-frame, .block-wrapper").addClass("hidden");
    $(".map-wrapper").addClass("shadow-none");
    overlayForScreenshot(true);

    const element = document.querySelector(".poster-wrapper");

    try {
      const canvas = await html2canvas(element, {
        scale: window.devicePixelRatio || 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      });

      PosterPreviewImage = canvas.toDataURL("image/jpeg", 0.8);
      $(".js-poster-preview").attr("src", PosterPreviewImage);

      return PosterPreviewImage;
    } finally {
      overlayForScreenshot(false);
      $(".map-wrapper").removeClass("shadow-none");
      $(".poster-frame, .block-wrapper").removeClass("hidden");
    }
  }

  // For faking the map gradient transparency in the screenshot
  function overlayForScreenshot(toggle) {
    const overlayColors = {
      silver: "220,218,219",
      gold: "223,207,170",
      bronze: "209,176,128",
      rose: "195,132,121",
      black: "0,0,0",
      tegel: "244,244,246",
      default: "255,255,255",
    };

    // Determine the overlay color based on AluminiumColor and PrintType
    const overlayColor =
      AluminiumColor === "silver" && PrintType === "aluminium"
        ? overlayColors.silver
        : AluminiumColor === "gold" && PrintType === "aluminium"
          ? overlayColors.gold
          : AluminiumColor === "rose" && PrintType === "aluminium"
            ? overlayColors.rose
            : AluminiumColor === "bronze" && PrintType === "aluminium"
              ? overlayColors.bronze
              : PosterStyle === "3" && ["paper"].includes(PrintType)
                ? overlayColors.black
                : PrintType === "tegel"
                  ? overlayColors.tegel
                  : overlayColors.default;

    // Create the label gradient
    const labelGradient = `linear-gradient(0deg, rgba(${overlayColor},1) 50%, rgba(${overlayColor},0) 100%)`;

    // Apply the styles based on the toggle
    const stopColor = toggle ? `rgb(${overlayColor})` : "transparent";
    const backgroundColor = toggle ? labelGradient : "transparent";

    // Update the stop colors and background
    $("#radialGradient-1 stop, #radialGradient-2 stop").attr(
      "stop-color",
      stopColor,
    );
    $(".poster-canvas .labels").css("background", backgroundColor);
  }

  // For hiding some unnecessary fields on staging
  function toggleProductionEnv() {
    if (process.env.OAK_FRAMES === "false") {
      $('[data-frame="oak"]').remove();
    }
    if (process.env.ACRYL_PRODUCTS === "false") {
      if (PrintType === "acryl") {
        PrintType = "paper";
        PosterWrapper.removeClass("acryl");
      }
      $(".js-show-for-acryl").remove();
      $(".js-hide-for-acryl").show();
      $(".js-material-toggle [data-print='acryl']").remove();
    }
    if (process.env.ALUMINIUM_PRODUCTS === "false") {
      if (PrintType === "aluminium") {
        PrintType = "paper";
        PosterWrapper.removeClass("aluminium");
      }
      $(".js-show-for-aluminium").remove();
      $(".js-hide-for-aluminium").show();
      $(".js-material-toggle [data-print='aluminium']").remove();
    }
  }

  // For removing default values from poster
  function sanitizePosterInput(value) {
    if (value === undefined || value === null || value === "undefined") {
      return "";
    }

    value = String(value);

    var defaultValues = [
      t("sportsmap.defaults.location"),
      t("sportsmap.defaults.dateDistance"),
      t("sportsmap.defaults.nameTime"),
      t("sportsmap.defaults.achievement"),
      "Jouw naam & tijd",
      "Jouw naam &amp; tijd",
      "Jouw naam & datum",
      "Jouw naam &amp; datum",
      "Jouw naam",
      "Jouw sportprestatie",
      "Sportprestatie",
      "Plaatsnaam",
      "Datum / afstand",
    ];

    var isMatch = false;

    for (var i = 0; i < defaultValues.length; i++) {
      if (defaultValues[i] === value) {
        isMatch = true;
        break;
      }
    }

    if (isMatch) {
      return "";
    } else {
      return value;
    }
  }

  // For saving design to local storage
  function saveDesign() {
    localStorage.setItem("posterSize", PosterSize);
    localStorage.setItem("posterFrame", PosterFrame);
    localStorage.setItem("posterKader", PosterKader);
    localStorage.setItem("SMPosterStyle", PosterStyle);
    localStorage.setItem("SMFontStyle", FontStyle);
    localStorage.setItem("posterOrientation", PosterOrientation);
    localStorage.setItem("sportsmapLocation", CoordinatesLabel.html());
    localStorage.setItem("sportsmapMain", MainTextLabel.html());
    localStorage.setItem("sportsmapSubtitle", SubtitleLabel.html());
    localStorage.setItem("sportsmapSubtitle2", Subtitle2Label.html());
    localStorage.setItem("mapCoordinates", JSON.stringify(mapCoordinates));
    localStorage.setItem("mapZoom", MapZoom);
    localStorage.setItem("routeColor", routeColor);
    localStorage.setItem("startColor", startColor);
    localStorage.setItem("endColor", endColor);
    localStorage.setItem("showEndPoints", showEndPoints);
    localStorage.setItem("unlockMap", unlockMap);
    localStorage.setItem("routeThickness", routeThickness);
    localStorage.setItem("printType", PrintType);
    localStorage.setItem("acrylBlock", AcrylBlock);
    localStorage.setItem("aluminiumColor", AluminiumColor);
    localStorage.setItem("labelsOverRoute", labelsOverRoute);

    // Route data is tab-scoped by route-store and persisted permanently on save.
    localStorage.removeItem("geojsonString");
  }

  function createDesignSnapshot() {
    return JSON.stringify({
      routes: serializeRoutes(),
      labels: {
        coordinates: CoordinatesLabel.html(),
        main: MainTextLabel.html(),
        subtitle: SubtitleLabel.html(),
        subtitle2: Subtitle2Label.html(),
      },
      poster: {
        size: PosterSize,
        frame: PosterFrame,
        kader: PosterKader,
        style: PosterStyle,
        orientation: PosterOrientation,
        printType: PrintType,
        fontStyle: FontStyle,
        acrylBlock: AcrylBlock,
        aluminiumColor: AluminiumColor,
        giftwrap: PosterGiftwrapSelect.val(),
        giftcardText: GiftCardText,
        labelsOverRoute,
        unlockMap,
      },
    });
  }

  window.addEventListener("beforeunload", (event) => {
    const designChanged =
      initialDesignSnapshot !== null &&
      (mapWasEdited || createDesignSnapshot() !== initialDesignSnapshot);

    if (BuilderName === "PrintApp" || designWasSubmitted || !designChanged) {
      return;
    }

    event.preventDefault();
    event.returnValue = "";
  });

  // For getting design from local storage or parameters
  function getSavedPoster() {
    mapCoordinates = options.get("mapCoordinates");

    if (searchParams("newPrint")) {
      localStorage.clear();
    }

    if (!mapCoordinates) {
      return;
    }

    MapZoom = options.get("mapZoom");

    if (BuilderName !== "PrintApp") {
      RoutesModal = new bootstrap.Modal(
        document.getElementById("routes-modal"),
      );
    }

    // Prepare text labels
    if (BuilderName !== "PrintApp" && !searchParams("edit")) {
      if (options.get("sportsmapMain") !== null) {
        var mainLabel = options.get("sportsmapMain");
      } else {
        var mainLabel = t("sportsmap.defaults.location");
      }

      if (options.get("sportsmapSubtitle") !== null) {
        var subLabel = options.get("sportsmapSubtitle");
      } else {
        var subLabel = t("sportsmap.defaults.dateDistance");
      }

      if (options.get("sportsmapSubtitle2") !== null) {
        var subLabel2 = options.get("sportsmapSubtitle2");
      } else {
        var subLabel2 = t("sportsmap.defaults.nameTime");
      }

      if (options.get("sportsmapLocation") !== null) {
        var coordsLabel = options.get("sportsmapLocation");
      } else {
        var coordsLabel = t("sportsmap.defaults.achievement");
      }
    } else {
      var mainLabel = options.get("sportsmapMain");
      var subLabel = options.get("sportsmapSubtitle");
      var subLabel2 = options.get("sportsmapSubtitle2");
      var coordsLabel = options.get("sportsmapLocation");

      if (options.get("routeColor") && options.get("routeColor") !== "null") {
        routeColor = options.get("routeColor");
        RouteColorInput.val(routeColor);
      }
      if (options.get("startColor") && options.get("startColor") !== "null") {
        startColor = options.get("startColor");
        StartColorInput.val(startColor);
      }
      if (options.get("endColor") && options.get("endColor") !== "null") {
        endColor = options.get("endColor");
        EndColorInput.val(endColor);
      }
    }

    // Set text labels
    if (!hasRouteQueryParam) {
      MainTextLabel.html(mainLabel);
      MainTextInput.val(mainLabel);
      SubtitleLabel.html(subLabel);
      SubtitleInput.val(subLabel);
      Subtitle2Label.html(subLabel2);
      Subtitle2Input.val(subLabel2);
      CoordinatesLabel.html(coordsLabel);
      CoordinatesInput.val(coordsLabel);
    }

    if (PrintType !== "tegel") {
      PosterOrientation = options.get("posterOrientation");
      if (options.get("posterOrientation") === "null") {
        PosterOrientation = "portrait";
      } else {
        PosterOrientation = options.get("posterOrientation");
      }
      PosterOrientationSelect.val(PosterOrientation);
      setPosterOrientation(PosterOrientation);
    }

    if (PrintType !== "acryl" && PrintType !== "aluminium") {
      if (PosterSize === "xs") {
        PosterSize = "small";
      }
      if (PrintType === "framed-poster") {
        PrintType = "paper";
      }
    }
    PosterSizeSelect.val(PosterSize);
    setPosterSize(PosterSize);
    PosterFrameSelect.val(PosterFrame);
    setGiftwrap(PosterFrame);

    PosterKader = options.get("posterKader");
    PosterKaderSelect.val(PosterKader);
    setPosterKader(PosterKader);

    if (
      localStorage.getItem("SMPosterStyle") === "null" ||
      localStorage.getItem("SMPosterStyle") === null ||
      localStorage.getItem("SMPosterStyle") === ""
    ) {
      localStorage.setItem("SMPosterStyle", 1);
    } else if (
      PrintType === "aluminium" &&
      localStorage.getItem("SMPosterStyle") === "3"
    ) {
      localStorage.setItem("SMPosterStyle", 1);
    }
    PosterStyle = options.get("SMPosterStyle");
    window.PosterStyle = String(PosterStyle);
    PosterStyleSelect.val(PosterStyle);

    RouteThicknessInput.val(routeThickness);
    RouteColorInput.val(routeColor);
    StartColorInput.val(startColor);
    EndColorInput.val(endColor);

    if (unlockMap) {
      LockMapIcon.removeClass("fa-lock").addClass("fa-lock-open");
      $(".center-pin-wrapper").removeClass("d-none");
    }

    PrintTypeSelect.val(PrintType);
    setPrintType(PrintType);
    setAluminiumColorSelection(AluminiumColor);
    $(".js-toggle-for-material").hide();
    togglePrintTypes();
    setPosterFontStyle(FontStyle);
    setPosterFontSelection(FontStyle);
    syncMapStyleSelector();
    syncKaderSelector();
    syncOrientationSelector();

    map.once("style.load", () => {
      setPosterStyle(PosterStyle);
    });
  }

  // Resize canvas
  $(window).on("resize", function () {
    resizePosterWrapper();
  });

  function resizePosterWrapper() {
    resizePosterPreview();
  }

  window.visualViewport?.addEventListener("resize", resizePosterWrapper);

  // Toggle settings panels
  $(".js-settings-toggle").on("click", function () {
    var target = $(this).attr("data-target");
    setActivePanel(target);
  });

  function setActivePanel(target) {
    $(".nav-link").removeClass("active");
    $(".nav-link[data-target=" + target + "]").addClass("active");

    if (target == "map" && SettingsPanel !== "map") {
      $(".settings-panel").addClass("d-none");
      $(".settings-panel.map").removeClass("d-none");
      SettingsPanel = "map";
    } else if (target == "text" && SettingsPanel !== "text") {
      $(".settings-panel").addClass("d-none");
      $(".settings-panel.text").removeClass("d-none");
      SettingsPanel = "text";
    } else if (target == "size" && SettingsPanel !== "size") {
      $(".settings-panel").addClass("d-none");
      $(".settings-panel.size").removeClass("d-none");
      SettingsPanel = "size";
    } else if (target == "shop" && SettingsPanel !== "shop") {
      setPosterSummary();
      $(".settings-panel").addClass("d-none");
      $(".settings-panel.shop").removeClass("d-none");
      $(".nav-pills .nav-link").removeClass("active");
      $("#pills-shop-tab").addClass("active");
      SettingsPanel = "shop";
    }

    if (ShowMobileSettingPanel == false) {
      $(".side-nav").addClass("shown");
      ShowMobileSettingPanel = true;
    }
    $(".options-container").scrollTop(0);
    saveDesign();
  }

  $(".js-close-settings").on("click", function () {
    dismissSettingsPanel();
  });

  function dismissSettingsPanel() {
    $(".side-nav").removeClass("shown");
    ShowMobileSettingPanel = false;
  }

  // Prepping shopping cart
  function setPosterSummary() {
    getShoppingBagSummary(PosterSize, PrintType, PosterFrame, AcrylBlock, t);
    $(".js-shipping-date").text(getShippingDate({ t, formatDate }));
    createPosterPreview();
  }

  // For dismissing panel if previewing from shopping cart
  function setPreviewMode() {
    if (searchParams("preview")) {
      dismissSettingsPanel();
    }
  }

  // for searching parameters
  function searchParams(query) {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has(query)) {
      return true;
    } else {
      return false;
    }
  }

  // For finding the right poster variation ID
  function findProductVariation(variationKey) {
    const configuredProduct = resolveCatalogProduct(
      marketContext.catalog,
      "sportsmap",
      PrintType,
      variationKey,
    );
    return configuredProduct;
  }

  // For creating product key
  function createProductKey() {
    let ProductKey;
    if (PrintType === "acryl" || PrintType === "aluminium") {
      ProductKey = PosterSize + "-" + PrintType;
    } else if (PrintType === "tegel") {
      ProductKey = PrintType;
    } else {
      ProductKey = PosterSize + "-" + PosterFrame;
    }
    return ProductKey;
  }

  function getMapCenterArray() {
    const center = map.getCenter();
    return [center.lng, center.lat];
  }

  async function uploadPendingRoutes() {
    const uploads = Array.from(routeStore.values()).map(async (route) => {
      if (route.geojsonUrl) return route;
      if (!route.geojson) {
        throw new Error(`Route ${route.name} bevat geen GeoJSON-data.`);
      }

      const uploadedUrl = await uploadGeoJson(route.geojson, "sportsmap");
      return updateRoute(route.id, { geojsonUrl: uploadedUrl });
    });

    await Promise.all(uploads);
  }

  function buildSportsmapConfig() {
    return {
      version: 2,
      type: "sportsmap",
      market: marketContext.market,
      locale: marketContext.locale,
      printType: PrintType,
      mapCoordinates: getMapCenterArray(),
      mapZoom: map.getZoom(),
      routes: serializeRoutes(),
      coordinatesLabel: sanitizePosterInput(
        localStorage.getItem("sportsmapLocation"),
      ),
      main: sanitizePosterInput(localStorage.getItem("sportsmapMain")),
      subtitle: sanitizePosterInput(localStorage.getItem("sportsmapSubtitle")),
      subtitle2: sanitizePosterInput(
        localStorage.getItem("sportsmapSubtitle2"),
      ),
      labelsOverRoute,
      unlockMap,
      SMPosterStyle: PosterStyle,
      SMFontStyle: FontStyle,
      size: PosterSize,
      frame: PrintType === "paper" ? PosterFrame : null,
      kader: PosterKader,
      orientation: PosterOrientation,
      aluminiumColor:
        PrintType === "aluminium"
          ? localStorage.getItem("aluminiumColor")
          : null,
      acrylBlock: ["aluminium", "acryl", "tegel"].includes(PrintType)
        ? localStorage.getItem("acrylBlock")
        : null,
      giftwrap: PosterGiftwrapSelect.val() === "true",
      giftcardText: GiftCardText || "",
    };
  }

  // Adding poster to cart
  $(".js-save-poster").on("click", async function () {
    const saveButton = $(this);
    if (routeStore.size === 0) {
      showRouteError(
        t("sportsmap.errors.routeRequired"),
      );
      return;
    }
    saveDesign();
    const ProductVariationKey = createProductKey();
    const ProductVariation = findProductVariation(ProductVariationKey);

    saveButton
      .html(
        `${t("sportsmap.shop.saving")} <span class="spinner-border spinner-border-sm ms-2" aria-hidden="true"></span>`,
      )
      .prop("disabled", true);

    let thumbnailUrl;
    let configUrl;
    try {
      const thumbnail = await createPosterPreview();
      await uploadPendingRoutes();
      [configUrl, thumbnailUrl] = await Promise.all([
        uploadJson(buildSportsmapConfig(), "sportsmap"),
        uploadProductScreenshot(thumbnail, BuilderName),
      ]);
    } catch (error) {
      console.error("Sportsmap kon niet worden opgeslagen", error);
      showRouteError(
        t("sportsmap.errors.saveFailed"),
      );
      saveButton.text(t("actions.addToCart")).prop("disabled", false);
      return;
    }

    const archiveRoute = Array.from(routeStore.values()).find(
      (route) => route.source?.type === "archive" && route.source.routeId,
    );
    let payload = {
      "add-builder-item-to-cart": true,
      edit_url: getBuilderUrl(marketContext, "sportsmap-poster", "/?preview"),
      thumbnail: thumbnailUrl,
      product_id: ProductVariation.id,

      route: archiveRoute
        ? {
            id: Number(archiveRoute.source.routeId),
            name: archiveRoute.source.name || archiveRoute.name || "",
            event: archiveRoute.source.event || "",
            location: archiveRoute.source.location || "",
            year: archiveRoute.source.year || "",
          }
        : null,

      ...(PrintType !== "tegel" && {
        variation_id: ProductVariation.variationId,
      }),
      poster: {
        configFileUrl: configUrl,
        printType: PrintType,
        size: PosterSize,
        orientation: PosterOrientation,
        giftwrap: PosterGiftwrapSelect.val(),
        coordinatesLabel: sanitizePosterInput(
          localStorage.getItem("sportsmapLocation"),
        ),
        main: sanitizePosterInput(localStorage.getItem("sportsmapMain")),
        subtitle: sanitizePosterInput(
          localStorage.getItem("sportsmapSubtitle"),
        ),
        subtitle2: sanitizePosterInput(
          localStorage.getItem("sportsmapSubtitle2"),
        ),
        giftcardText: GiftCardText,
        ...(["aluminium"].includes(PrintType) && {
          aluminiumColor: localStorage.getItem("aluminiumColor"),
        }),
        ...(["aluminium", "acryl", "tegel"].includes(PrintType) && {
          acrylBlock: localStorage.getItem("acrylBlock"),
        }),
      },
      pdf: {
        type: "sportsmap",
        print:
          PrintType === "paper" && PosterFrame !== "no-frame"
            ? "framed-poster"
            : PrintType,
      },
    };

    // console.log("Payload: ", payload);

    let action =
      process.env.USE_CART === "true" ? "add-to-cart" : "add-poster-order";
    const endpoint = woocommerceUrl + "/wp-json/wallable/v1/" + action;
    let didRetryAsForm = false;

    const runAjax = (useFormEncoding = false) => {
      return $.ajax({
        url: endpoint,
        type: "POST",
        timeout: 20000,

        ...(useFormEncoding
          ? {
              data: { payload: JSON.stringify(payload) },
            }
          : {
              contentType: "application/json",
              data: JSON.stringify(payload),
            }),

        error: (jqXHR, textStatus, errorThrown) => {
          if (!useFormEncoding && !didRetryAsForm && jqXHR?.status === 0) {
            didRetryAsForm = true;
            return runAjax(true);
          }

          console.error(jqXHR, textStatus, errorThrown);

          setTimeout(() => {
            if (!$(".js-notifications").find(".js-error").length) {
              $(".js-notifications").append(
                `<div class="js-error alert alert-danger text-center p-2">${t("sportsmap.errors.cartFailed")}</div>`,
              );
            }

            debugReporter.show({
              meta: { action, didRetryAsForm },
              request: {
                url: endpoint,
                method: "POST",
                mode: useFormEncoding ? "form" : "json",
                origin: window.location.origin,
                woocommerceUrl,
                online: navigator.onLine,
                visibilityState: document.visibilityState,
              },
              response: {
                status: jqXHR?.status,
                statusText: jqXHR?.statusText || textStatus,
                thrownError: errorThrown ? String(errorThrown) : null,
                responseText: (jqXHR?.responseText || "").slice(0, 4000),
              },
            });

            saveButton
              .text(t("actions.addToCart"))
              .prop("disabled", false);
          }, 500);
        },

        success: () => {
          designWasSubmitted = true;

          if (action === "add-to-cart") {
            saveButton
              .text(t("actions.addToCart"))
              .prop("disabled", false);

            window.location = woocommerceUrl + "/cart/";
          } else {
            if (!$(".js-notifications").find(".js-error").length) {
              $(".js-notifications").append(
                `<div class="js-success alert alert-success text-center p-2">&#x2713; ${t("sportsmap.shop.added")}</div>`,
              );
            }
            saveButton
              .text(t("actions.addToCart"))
              .prop("disabled", false);
          }
        },
      });
    };

    runAjax(false);
  });

  // Product tour and predefined routes
  if (BuilderName !== "PrintApp") {
    var tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]'),
    );
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl);
    });
  }

  $(".js-init-routes").on("click", function () {
    if (!RoutesInitialized) {
      loadStoredRoutes();
      RoutesInitialized = true;
    }
  });
  await startupPromise;
}

const startupController = new AbortController();
let startupFailed = false;
function showStartupError(error) {
  if (startupFailed) return;
  startupFailed = true;
  startupController.abort(error);
  console.error("Sportsmap kon niet worden gestart", error);
  window.status = "mapbox-error";
  $(".anim-wrapper").addClass("hidden");
  $(".loading-wrapper")
    .empty()
    .attr("role", "alert")
    .append(
      $("<p>").text(
        t("sportsmap.errors.startupFailed"),
      ),
    )
    .append(
      $("<button>", { type: "button", class: "btn btn-primary" })
        .text(t("actions.retry"))
        .on("click", () => window.location.reload()),
    );
}
// Production print rendering can be slower than the interactive preview.
// Keep the print deadline below wallable-print's 120-second readiness timeout.
const startupTimeoutMs = document.body.id === "PrintApp" ? 110_000 : 45_000;
const startupTimeout = setTimeout(
  () => showStartupError(new Error("Het laden van het ontwerp duurt te lang.")),
  startupTimeoutMs,
);
initializeSportsmap(startupController.signal)
  .catch(showStartupError)
  .finally(() => clearTimeout(startupTimeout));
